function getSessionData(ga4Id: string) {
  if (typeof document === 'undefined') {
    return { gaSessionId: '', gaSessionNumber: '' }
  }
  const pattern = new RegExp(`_ga_${ga4Id}=GS\\d\\.\\d\\.(.+?)(?:;|$)`)
  const match = document?.cookie?.match(pattern)
  const parts = match?.[1]?.split('.')

  return {
    gaSessionId: parts?.shift(),
    gaSessionNumber: parts?.shift(),
  }
}

export default getSessionData
